import { z } from 'zod';

export const loginParamsSchema = z.object({
  email: z.string().catch(''),
  password: z.string().catch(''),
});
